import React from "react";
import { useDispatch, useSelector } from "react-redux";

import { IDetailedKs2InDocs } from "redux/modules/common/building/documents/ksList/types";
import {
  ks2SectionsAttachmentsSelector,
  passportsInvalidateKeySelector,
} from "redux/modules/common/passportsAndCertificates/selectors";
import { getKs2SectionAttachments } from "redux/modules/common/passportsAndCertificates/thunks";
import { DocumentsTypesEnum, IAttachmentInExpenditure } from "redux/modules/common/passportsAndCertificates/types";

import FilesModalKs2Section from "components/modals/ExpenditureFilesModal/FilesModalKs2Section";
import { checkExpenditureAttachmentIsWarn } from "components/modals/PassportsAndSertificates/utils";
import AosrExistingModal from "components/pages/Journal/components/JournalDone/components/JournalExecTicket/components/Aosr/AosrExistingModal/AosrExistingModal";

import KS3PageSubRowExpenditure from "./KS3PageSubRowExpenditure";
import ExpandPillTrigger from "shared/ui/controls/ExpandPillTrigger/ExpandPillTrigger";
import FilesClipButton from "shared/ui/controls/FilesClipButton/FilesClipButton";
import StatusElement from "shared/ui/dataDisplay/StatusElement/StatusElement";
import { TableReusableCell } from "shared/ui/dataDisplay/TableReusable/TableReusableRow";

import { ExpenditureTypeEnum } from "types/enums/ExpenditureTypeEnum";
import { ITicketInJournalDone } from "types/interfaces/Tickets";

import { useObjectId } from "hooks/useObjectId";

import { getAttachmentName } from "../../utils";
import { splitThousands } from "utils/formatters/splitThousands";

import styles from "./KS3PageRowContent.module.scss";

interface IProps {
  isFirst?: boolean;
  expenditure: IDetailedKs2InDocs["items"][0]["expenditures"][0];
  section: IDetailedKs2InDocs["items"][0];
  ks2Id: number;
}

const KS3PageSubRow: React.FC<IProps> = ({ isFirst, expenditure, section, ks2Id }) => {
  const dispatch = useDispatch();

  const [isSectionFilesRow, setIsSectionFilesRow] = React.useState(!!section.attachments_count);
  const [isSectionModal, setIsSectionModal] = React.useState(false);

  const toggleSectionFilesRow = React.useCallback(() => {
    setIsSectionFilesRow((prev) => !prev);
  }, []);

  const toggleSectionModal = React.useCallback(() => {
    setIsSectionModal((prev) => !prev);
  }, []);

  const invalidateDocsKey = useSelector(passportsInvalidateKeySelector);
  const sectionAttachments = useSelector(ks2SectionsAttachmentsSelector)[`${ks2Id}_${section?.section_id}`];

  const filteredSectionAttachments = React.useMemo(() => {
    return sectionAttachments?.results?.filter((el) => el.type !== DocumentsTypesEnum.file);
  }, [sectionAttachments]);

  React.useEffect(() => {
    if (!isSectionFilesRow) return;
    dispatch(getKs2SectionAttachments(ks2Id, section.section_id));
  }, [invalidateDocsKey, ks2Id, isSectionFilesRow, section.section_id]);

  return (
    <>
      {isFirst && (
        <PreRow
          section={section}
          toggleSectionFilesRow={toggleSectionFilesRow}
          toggleSectionModal={toggleSectionModal}
          isSectionFilesRow={isSectionFilesRow}
          filteredSectionAttachments={filteredSectionAttachments}
        />
      )}
      <KS3PageSubRowExpenditure expenditure={expenditure} ks2Id={ks2Id} sectionId={section.section_id} />
      <FilesModalKs2Section
        isOpen={isSectionModal}
        onClose={toggleSectionModal}
        ks2Id={ks2Id}
        sectionId={section.section_id}
      />
    </>
  );
};

export default React.memo(KS3PageSubRow);

function PreRow({
  section,
  toggleSectionModal,
  toggleSectionFilesRow,
  isSectionFilesRow,
  filteredSectionAttachments,
}: {
  section: IDetailedKs2InDocs["items"][0];
  toggleSectionModal: () => void;
  toggleSectionFilesRow: () => void;
  isSectionFilesRow: boolean;
  filteredSectionAttachments: IAttachmentInExpenditure[];
}) {
  return (
    <div className={styles.section}>
      <div className={styles.sectionRow}>
        <TableReusableCell isNoBreak>{section.section_name}</TableReusableCell>
        <TableReusableCell className={styles.opacity}>К сдаче</TableReusableCell>
        <TableReusableCell isRightedWithPadding>{splitThousands(section.amount)}</TableReusableCell>
        <TableReusableCell className={styles.opacity}>Расценки</TableReusableCell>
        <TableReusableCell isRighted>{section.expenditures.length}</TableReusableCell>
        <div></div>
        <TableReusableCell>
          <FilesClipButton onClick={toggleSectionModal} />
        </TableReusableCell>
        {/* <TableReusableCell>
          {!!section.attachments_count && (
            <ExpandPillTrigger
              isExpanded={isSectionFilesRow}
              toggleExpand={toggleSectionFilesRow}
              variant="success"
              label={`${section.attachments_count}`}
            />
          )}
        </TableReusableCell> */}
      </div>
      {isSectionFilesRow && (
        <div className={styles.filesRowOuter}>
          {filteredSectionAttachments?.map((el) => (
            <StatusElement key={el.id} status="success" text={getAttachmentName(el)} onClick={toggleSectionModal} />
          ))}
        </div>
      )}
    </div>
  );
}
